import React from 'react';

const stop = (event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation();
export const StopPropagation: React.FC = ({ children }) => (
    <div onClick={stop}>
        {children}
    </div>
);